const SendChatMessage = gql`
  mutation SendChatMessage($input: SendChatMessageInput!) {
    sendChatMessage(input: $input) {
      conversationId
      documentIds
    }
  }
`;

const GetConversationPage = gql`
  query GetConversationPage($input: StandardPageInput) {
    conversationPage(input: $input) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          title
          metadata
          createdAt
          updatedAt
        }
      }
    }
  }
`;

const GetConversation = gql`
  query GetConversation($id: Int!) {
    conversation(id: $id) {
      messages {
        role
        content
        checksum
        createdAt
      }
    }
  }
`;

const GetMessage = gql`
  query GetMessage($id: Int!) {
    message(id: $id) {
      id
      role
      content
      checksum
      createdAt
      documents {
        id
        url
        title
      }
    }
  }
`;

const GetMessagePage = gql`
  query GetMessagePage($input: MessagePageInput!) {
    messagePage(input: $input) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          role
          content
          checksum
          createdAt
          documents {
            id
            url
            title
          }
        }
      }
    }
  }
`;

export default { SendChatMessage, GetConversationPage, GetConversation, GetMessage, GetMessagePage };
